export enum AppChartType {
  DEMAND = 'demand',
  CAPACITY = 'capacity',
  CAPEX = 'capex',
  REVENUE = 'revenue',
  LTE = 'lte',
  FTE = 'fte',
  INVENTORY = 'inventory',
  WAREHOUSE_CASES = 'warehouse_cases',
  WAREHOUSE_SPACE = 'warehouse_space',
  INCREMENTAL_REVENUE = 'incremental_revenue',
  INCREMENTAL_GROSS_PROFIT = 'incremental_gross_profit',
  CAPEX_REQ_PERCENT_REVENUE = 'capex_req_percent_revenue',
  POTENTIAL_REVENUE_LOSS = 'potential_revenue_loss',
  INCREMENTAL_DEMAND = 'incremental_demand',
  INCREMENTAL_CAPACITY = 'incremental_capacity',
  PRODUCTION = 'production',
  NEW_LINES = 'new_lines',
  INCREMENTAL_INVENTORY = 'incremental_inventory',
  INC_INVENTORY = 'inc_inventory',
  ADD_PALLET_POS_REQUIRED = 'add_pallet_pos_required',
  CAPEX_REQUIRED = 'capex_required',
  INC_DEMAND_THROUGHPUT = 'inc_demand_throughput',
  INCREMENTAL_THROUGHPUT_REQUIRED = 'incremental_throughput_required',
  C_to_D = 'c_to_d',
}
export enum PrecisionType {
  NONE = 1,
  TENTH = 10,
  HUNDREDTH = 100,
  THOUSANDTH = 1000,
  MILLIONTH = 1000000,
}
export enum UnitType {
  PERCENTAGE = '%',
  NONE = '',
}

